<lib-loader></lib-loader>
<lib-progresso></lib-progresso>
<div class="wrapper">
  <div id="content" [ngStyle]="{'background-color': this.color}">
    <app-navbar-transparencia *ngIf="mostrarMenu === true"></app-navbar-transparencia>
    <router-outlet></router-outlet>
  </div>
</div>
<footer *ngIf="login !== undefined"
  [ngStyle]="{'background-color': contraste ? '#212121' : '#212121', 'height': '120px', 'padding-top': '10px', 'padding-bottom': '20px'}">
  <div class="container" style="padding-bottom: 20px;">
    <p style="font-size: 12px; font-weight: bold; color: #fff;">{{login?.orgao?.nome}}</p>
    <p style="margin-top: 0.3em; margin-bottom: 0em; font-size: 11px; color: #fff;">CNPJ: {{login?.orgao?.cnpj}}</p>
    <p style="margin-top: 0.3em; margin-bottom: 0em; font-size: 11px; color: #fff;">{{login?.orgao?.endereco}} CEP:
      {{login?.orgao?.cep}}</p>
    <p style="margin-top: 0.3em; margin-bottom: 0em; font-size: 11px; color: #fff;">{{login?.orgao?.bairro}} -
      {{login?.cidade?.nome}}</p>
  </div>
  <div class="container" class="footer-copyright" style="background-color: #424242;">
    <p class="text-center" style="font-size: 11px; font-weight: bold; color: #fff;">{{copyright()}}<span
        id="eddy_login-versao">{{versao()}}</span></p>
  </div>
</footer>
<app-lgpd></app-lgpd>